class EbwVideoPlayer extends HTMLElement {
  constructor() {
    super();
    this.video = null;
    this.playButton = null;
    this.wrapper = null;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.video = this.querySelector('video');
    this.playButton = this.querySelector('[data-play-button]');
    this.wrapper = this.querySelector('[data-video-wrapper]');

    if (!this.video || !this.playButton) return;

    // Event listeners para el botón de play/pausa
    this.playButton.addEventListener('click', (e) => this.togglePlayPause(e));

    // Event listeners para el video
    this.video.addEventListener('play', () => this.onPlay());
    this.video.addEventListener('pause', () => this.onPause());

    // Mostrar el botón al pasar el mouse sobre el video
    this.wrapper?.addEventListener('mouseenter', () => this.showPlayButton());
    this.wrapper?.addEventListener('mouseleave', () => this.hidePlayButtonIfPlaying());

    // En dispositivos táctiles, mostrar/ocultar al hacer tap
    this.video.addEventListener('touchstart', () => this.toggleButtonVisibility());
  }

  togglePlayPause(e) {
    e.preventDefault();
    if (this.video.paused) {
      this.video.play();
    } else {
      this.video.pause();
    }
  }

  onPlay() {
    this.wrapper?.classList.add('is-playing');
  }

  onPause() {
    this.wrapper?.classList.remove('is-playing');
  }

  showPlayButton() {
    this.playButton.classList.remove('is-hidden');
  }

  hidePlayButtonIfPlaying() {
    if (!this.video.paused) {
      this.playButton.classList.add('is-hidden');
    }
  }

  toggleButtonVisibility() {
    this.playButton.classList.toggle('is-hidden');
  }

  disconnectedCallback() {
    if (this.video) {
      this.video.removeEventListener('play', () => this.onPlay());
      this.video.removeEventListener('pause', () => this.onPause());
    }
  }
}

customElements.define('ebw-video-player', EbwVideoPlayer);
